<script lang="ts" setup>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import FadeSlideTransition from '@shared/animation/transitions/FadeSlideTransition/FadeSlideTransition.vue';
import { computed } from 'vue';

const props = defineProps<{
  padding?: 'none' | 'sm' | 'md' | 'lg';
}>();

const open = defineModel<boolean>('open', { default: false });

const isSticky = defineModel<boolean>('isSticky', { default: false });

const paddingClass = computed(() => {
  switch (props.padding) {
    case 'none':
      return '';
    case 'sm':
      return 'py-2 px-4';
    case 'lg':
      return 'p-6';
    case 'md':
    default:
      return 'p-4';
  }
});

function toggleOpen() {
  open.value = !open.value;
}
</script>

<template>
  <div
    class="collapsible-section border-grey-200 [&+.collapsible-section]:border-t"
    :class="paddingClass"
  >
    <button
      @click="toggleOpen"
      class="flex w-full cursor-pointer items-center gap-2 border-none py-2 text-start font-bold"
      :class="{
        'sticky top-0 z-40 bg-grey-50': isSticky && open,
      }"
      type="button"
    >
      <div class="flex size-6 items-center justify-center">
        <FontAwesomeIcon
          icon="fas fa-chevron-right"
          :class="['transition-transform duration-300', { 'rotate-90': open }]"
        />
      </div>
      <slot name="title"></slot>
    </button>

    <FadeSlideTransition v-show="open" direction="down">
      <div class="cursor-default space-y-2">
        <slot name="content"></slot>
      </div>
    </FadeSlideTransition>
  </div>
</template>
